
const hideTheHouse = shouldHide => {
    const $homeBase = document.getElementById('homeBase');
    if($homeBase) {
        if (shouldHide) {
            $homeBase.classList.add('animated', 'fadeOut');
        } else {
            $homeBase.classList.remove('fadeOut');
            $homeBase.classList.add('animated', 'fadeIn');
        }
    }
};

export default hideTheHouse;
